
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKURepricingLaborDialog extends Common.GridEditorDialog<SKURepricingLaborRow> {
        protected getFormKey() { return SKURepricingLaborForm.formKey; }
        //protected getIdProperty() { return SKURepricingLaborRow.idProperty; }
        protected getLocalTextPrefix() { return SKURepricingLaborRow.localTextPrefix; }
        //protected getNameProperty() { return SKURepricingLaborRow.nameProperty; }
        //protected getService() { return SKURepricingLaborService.baseUrl; }
        protected getDeletePermission() { return SKURepricingLaborRow.deletePermission; }
        protected getInsertPermission() { return SKURepricingLaborRow.insertPermission; }
        protected getUpdatePermission() { return SKURepricingLaborRow.updatePermission; }

        protected form = new SKURepricingLaborForm(this.idPrefix);

    }
}